export const triggerDialog = (alertDialog, header, message) => {
    alertDialog.value.displayDialog = true;
    alertDialog.value.dialogHeader = header;
    alertDialog.value.dialogMessage = message;
};